export const today = () => new Date()

export const toStringAndPad = (component: number, width: number, char?: string) => {
    return component.toString().padStart(width, char || '0')
}

export const formatDateDDMMYYYY = (date: Date) => {
    return `${toStringAndPad(date.getDate(), 2)}/${toStringAndPad(date.getMonth() + 1, 2)}/${toStringAndPad(
        date.getFullYear(),
        4,
    )}`
}

export const formatDateYYYYMMDD = (date: Date) => {
    return `${toStringAndPad(date.getFullYear(), 4)}/${toStringAndPad(date.getMonth() + 1, 2)}/${toStringAndPad(
        date.getDate(),
        2,
    )}`
}

export const formatDateDDMM = (date: Date) => {
    return `${toStringAndPad(date.getDate(), 2)}/${toStringAndPad(date.getMonth() + 1, 2)}`
}
